__turbopack_context__.v({
  "centerX": "slider-module-scss-module__H1V-eW__centerX",
  "disabled": "slider-module-scss-module__H1V-eW__disabled",
  "filler": "slider-module-scss-module__H1V-eW__filler",
  "isActive": "slider-module-scss-module__H1V-eW__isActive",
  "mark": "slider-module-scss-module__H1V-eW__mark",
  "max": "slider-module-scss-module__H1V-eW__max",
  "min": "slider-module-scss-module__H1V-eW__min",
  "primary": "slider-module-scss-module__H1V-eW__primary",
  "secondary": "slider-module-scss-module__H1V-eW__secondary",
  "slider": "slider-module-scss-module__H1V-eW__slider",
  "step": "slider-module-scss-module__H1V-eW__step",
  "tooltip": "slider-module-scss-module__H1V-eW__tooltip",
  "track": "slider-module-scss-module__H1V-eW__track",
  "wrapper": "slider-module-scss-module__H1V-eW__wrapper",
});
